/**
 * Axios instance pre-configured for the MarketView REST API.
 *
 * - `baseURL` is taken from `REACT_APP_MARKETVIEW_URL` (set in the `.env` file).
 * - A 15-second timeout is applied to all requests to prevent silent hangs
 *   on network outages or slow API responses.
 *
 * Request and response interceptors are layered on top of this instance in
 * `request.ts` and `response.ts`; consumers should import from the barrel
 * `interceptors/index.ts` rather than from this file directly.
 */
import axios from "axios";

const api = axios.create({
  baseURL: process.env.REACT_APP_MARKETVIEW_URL,
  withCredentials: true,
  timeout: 60000, // Metadata can exceed 15s on large datasets; keep login stable
});

export default api;
